import { render, staticRenderFns } from "./SalesOrderItemQuantityDeliveryInformation.vue?vue&type=template&id=7dd53706&"
import script from "./SalesOrderItemQuantityDeliveryInformation.vue?vue&type=script&lang=ts&"
export * from "./SalesOrderItemQuantityDeliveryInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports